export const locale = {
    lang: 'en',
    data: {
        ORDER_DETAIL: {
            TITLE: 'Order Details',
            DATE_FORMAT_WITH_HOUR: "dd/MM/yyyy 'at' HH:mm",
            DATETIME_FORMAT: 'dd/MM/yyyy HH:mm',
            DATE_FORMAT: 'dd/MM/yyyy',
            DATE_FORMAT_DAY_MONTH: 'dd/MM',
            DATETIME_FORMAT_DAY_MONTH: 'dd/MM HH:mm',
            DATE_WITH_TIME: '{{ date }} at {{ time }}',
            MENU: {
                NAME: 'Order {{ number }}',
                DETAIL: 'Order Detail',
                BACK: 'Back',
                APPROVAL_DESCRIPTION: 'Your estimate is awaiting approval.',
                APPROVE: 'Approve',
                LABORATORY: 'Laboratory',
                RECEIVER: 'Received by',
                ADDRESS: 'Address',
                APP: 'App',
                STATUS: 'Status',
                CUSTOMER: 'Customer',
                CUSTOMERS: 'Customers',
                CUSTOMER_USER: 'Denstist',
                CREATED_AT: 'Creation Date',
                APPROVED_AT: 'Approval Date',
                EXPECTED_DATE: 'Expected Date',
                END_DATE: 'End Date',
                CREATED_BY: 'Created by',
                PATIENT: 'Patient',
                PATIENT_GENDER: 'Gender',
                PATIENT_BIRTHDATE: 'Birthdate',
                RATING: 'Rating',
                CREATE_RATING: 'Create Rating',
                DELIVERY_ROUTE: 'Delivery route',
            },
            DELIVERY_ROUTE: {
                FINISHED_DATE: 'Delivery date',
                EXPECTED_DATE: 'Expected date',
                TRACKING_NUMBER: 'Tracking code',
                PERIOD: 'Period',
                STATUS: 'Status',
            },
            REMAKE: {
                ORDER: 'Order',
                REMAKE: 'Remake',
                ADJUSTMENT: 'Adjustment',
                ORIGINAL_ORDER: 'Original',
                SEQUENCE: 'Sequence',
            },
            REMAKE_TYPE: {
                REMAKE: 'Remake',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Adjustment',
                ADJUSTMENT_INITIAL: 'A',
            },
            TOOLTIP: {
                IS_DELIVERY_CONFIRMED: 'Delivery confirmed',
            },
            TABS: {
                INFORMATION: 'Information',
                FILES: 'Files',
                CHAT: 'Chat',
            },
            FORM: {
                FIELDS: {
                    SEARCH: 'Search',
                },
            },
            TOASTR: {
                ORDER_APPROVE: {
                    SUCCESS: {
                        MESSAGE: 'Order approved successfully',
                    },
                },
            },
            MODAL: {
                ORDER_RATING: {
                    TITLE: 'Order Rating',
                },
                BUTTONS: {
                    CREATE: 'Create',
                    SAVE: 'Save',
                    PRINT: 'Print',
                    CANCEL: 'Cancel',
                },
            },
        },
    },
};
